import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['connectButton', 'communityList'];

  static values = {
    provider: String,
    communityId: String,
    canConnect: Boolean,
  };

  connect() {
    this.validateCredentials();
  }

  validateCredentials() {
    const requiredFields = this.getRequiredFields();
    const allFieldsValid = requiredFields.every((field) => {
      const input = this.element.querySelector(`[name*="${field}"]`);
      return input && input.value.trim() !== '';
    });

    this.canConnectValue = allFieldsValid;
  }

  credentialChanged() {
    this.validateCredentials();
  }

  communitySelected(event) {
    this.communityIdValue = event.target.value;
    this.validateCredentials();
  }

  canConnectValueChanged() {
    if (this.hasConnectButtonTarget) {
      this.connectButtonTarget.classList.toggle(
        'd-none',
        !this.canConnectValue
      );
    }
  }

  async connectToProvider(event) {
    event.preventDefault();

    if (!this.canConnectValue) {
      return;
    }

    const formData = this.buildFormData();

    try {
      const response = await fetch(this.connectButtonTarget.href, {
        method: 'POST',
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData,
      });

      const html = await response.text();
      window.Turbo.renderStreamMessage(html);

      if (!response.ok) {
        throw new Error(
          `Server error attempting to connect to ${this.providerValue}`
        );
      }
    } catch (error) {
      console.error('Connection error:', error);
      window.sendError('Auth provider connection error', error);
    }
  }

  buildFormData() {
    const formData = new URLSearchParams();
    const requiredFields = this.getRequiredFields();

    // Add CSRF token
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
    if (csrf) {
      formData.append('authenticity_token', csrf);
    }

    // Add provider-specific fields
    requiredFields.forEach((field) => {
      const input = this.element.querySelector(`[name*="${field}"]`);
      if (input) {
        formData.append(field, input.value);
      }
    });

    return formData;
  }

  getRequiredFields() {
    // Map provider to required fields for connection
    const providerFields = {
      alis: ['uid', 'access_token_secret', 'base_url'],
      yardi: ['uid', 'access_token_secret', 'base_url', 'api_url'],
      point_click_care: ['uid'],
    };

    return providerFields[this.providerValue] || ['uid', 'access_token_secret'];
  }
}
